import { Meta } from '../../../graphql/graphql';

export default function useMeta() {
	const getMetaAsObject = (meta: Meta[]) =>
		Object.fromEntries(meta.map(({ key, value }) => [key, value]));

	return {
		getMetaAsObject,
	};
}
